import hash from 'hash-it';
import hoistNonReactStatics from 'hoist-non-react-statics';
import isEqual from 'lodash.isequal';
import Stylis from 'stylis';
import PropTypes from 'prop-types';
import React from 'react';
import mapValues from 'lodash.mapvalues';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ThemeProvider = function (_React$Component) {
  _inherits(ThemeProvider, _React$Component);
  function ThemeProvider() {
    _classCallCheck(this, ThemeProvider);
    return _possibleConstructorReturn(this, (ThemeProvider.__proto__ || Object.getPrototypeOf(ThemeProvider)).apply(this, arguments));
  }
  _createClass(ThemeProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        theme: this.props.theme,
        crownTransform: this.props.transform
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return React.Children.only(this.props.children);
    }
  }]);
  return ThemeProvider;
}(React.Component);
ThemeProvider.childContextTypes = {
  theme: PropTypes.objectOf(PropTypes.any),
  crownTransform: PropTypes.func
};
ThemeProvider.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.objectOf(PropTypes.any),
  transform: PropTypes.func
};
ThemeProvider.defaultProps = {
  theme: {}
};

/*!***********************************!*\
  !***  @energysavvy/react-crown   ***!
  !***    ./src/withClassNames.js  ***!
/*!***********************************!*/

function transformWithClassNames(styles, transform, theme, props) {
  var transformedTheme = transform(theme, props);
  var fixedClassNames = mapValues(styles, function (value) {
    return value.replace(' ', '.');
  });
  return Object.assign(transformedTheme, fixedClassNames);
}
function withClassNames(styles) {
  var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (theme) {
    return theme;
  };
  if (transform && transform.length > 1) {
    return function (theme, props) {
      return transformWithClassNames(styles, transform, theme, props);
    };
  }
  return function (theme) {
    return transformWithClassNames(styles, transform, theme);
  };
}

/*!**********************************!*\
  !***  @energysavvy/react-crown  ***!
  !***    ./src/withPrefix.js     ***!
/*!**********************************!*/

function withPrefix(prefix) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    exclude = _ref.exclude;
  return function (context, content, selectors) {
    switch (context) {
      case 1:
        {
          selectors.forEach(function (selector, index) {
            if (!exclude || !exclude.test(selector)) {
              selectors[index] = prefix + " " + selector;
            }
          });
          return content;
        }
      default:
        return content;
    }
  };
}

/*!*************************************!*\
  !***  @energysavvy/react-crown     ***!
  !***    ./src/withReplacements.js  ***!
/*!*************************************!*/

function replace(replacements, themeTemplate) {
  return Object.keys(replacements).reduce(function (template, key) {
    return template.replace(new RegExp('([^\\w-]|^)' + key + '(?=[^\\w-]|$)', 'g'), function (match) {
      var group1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return '' + group1 + replacements[key];
    });
  }, themeTemplate);
}
function withReplacements(replacements) {
  return function (context, content, selectors) {
    switch (context) {
      case 1:
        {
          selectors.forEach(function (selector, index) {
            selectors[index] = replace(replacements, selector);
          });
          return replace(replacements, content);
        }
      default:
        return content;
    }
  };
}
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass$1 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$1(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function generateStyleSelector(theme, themeTemplate, displayName) {
  var args = Object.assign({
    themeTemplate: themeTemplate,
    displayName: displayName
  }, theme);
  return 'crown_' + hash(args, {
    algorithm: 'md5',
    encoding: 'hex'
  });
}
function generateStyleElement(theme, themeTemplate, styleSelector, crownTransform) {
  var replacements = Object.assign({
    styleSelector: styleSelector
  }, theme);
  var stylis = new Stylis();
  stylis.use(withReplacements(replacements));
  if (crownTransform) {
    stylis.use(crownTransform);
  }
  var renderedCSS = stylis('', themeTemplate);
  var styleElement = document.createElement('style');
  styleElement.setAttribute('id', styleSelector);
  styleElement.innerHTML = renderedCSS;
  return styleElement;
}
function getMostRelevantTheme(propTheme, contextTheme) {
  return propTheme || contextTheme || {};
}
function mountStyleElement(theme, themeTemplate, styleSelector, crownTransform) {
  if (!document.getElementById(styleSelector)) {
    document.head.appendChild(generateStyleElement(theme, themeTemplate, styleSelector, crownTransform));
  }
}
function shouldUpdate(currentProps, currentContext, nextProps, nextContext, transform) {
  var currentTheme = getMostRelevantTheme(currentProps.theme, currentContext.theme);
  var nextTheme = getMostRelevantTheme(nextProps.theme, nextContext.theme);
  if (transform && transform.length > 1) {
    // Function is expecting to use props as part of transform
    return !isEqual(transform(currentTheme, currentProps), transform(nextTheme, nextProps));
  }
  return !isEqual(currentTheme, nextTheme);
}
function crown(cssTemplate) {
  var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (theme) {
    return theme;
  };
  return function generateCrownedComponent(Component) {
    var Crowned = function (_React$Component) {
      _inherits$1(Crowned, _React$Component);
      function Crowned(props, context) {
        _classCallCheck$1(this, Crowned);
        var _this = _possibleConstructorReturn$1(this, (Crowned.__proto__ || Object.getPrototypeOf(Crowned)).call(this, props, context));
        var theme = _this.getCalculatedTheme(props.theme, context.theme, props); // eslint-disable-line react/prop-types
        _this.state = {
          styleSelector: generateStyleSelector(theme, cssTemplate, Component.displayName || Component.name)
        };
        return _this;
      }
      _createClass$1(Crowned, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          var theme = this.getCalculatedTheme(this.props.theme, this.context.theme, this.props); // eslint-disable-line react/prop-types
          mountStyleElement(theme, cssTemplate, this.state.styleSelector, this.context.crownTransform);
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps, nextContext) {
          if (shouldUpdate(this.props, this.context, nextProps, nextContext, transform)) {
            var theme = this.getCalculatedTheme(nextProps.theme, nextContext.theme, nextProps); // eslint-disable-line react/prop-types
            var styleSelector = generateStyleSelector(theme, cssTemplate, Component.displayName);
            this.setState({
              styleSelector: styleSelector
            });
            mountStyleElement(theme, cssTemplate, styleSelector, nextContext.crownTransform);
          }
        }
      }, {
        key: 'getCalculatedTheme',
        value: function getCalculatedTheme(propsTheme, contextTheme, allProps) {
          var highestPriorityTheme = getMostRelevantTheme(propsTheme, contextTheme);
          var transformedTheme = transform(highestPriorityTheme, allProps);
          return transformedTheme;
        }
      }, {
        key: 'render',
        value: function render() {
          var theme = getMostRelevantTheme(this.props.theme, this.context.theme); // eslint-disable-line react/prop-types
          return React.createElement(Component, _extends({}, this.props, {
            crownClassName: this.state.styleSelector,
            theme: theme
          }));
        }
      }]);
      return Crowned;
    }(React.Component);
    Crowned.displayName = 'Crowned(' + (Component.displayName || Component.name) + ')';
    Crowned.contextTypes = {
      theme: PropTypes.objectOf(PropTypes.any),
      crownTransform: PropTypes.func
    };
    Crowned.propTypes = Object.assign({
      theme: PropTypes.objectOf(PropTypes.any)
    }, Component.propTypes);

    // Hoists non React statics, such as Button.STANDARD, to this component,
    // so you can do things like:
    // import {Button} from '@energysavvy/customer-ui-components'
    // <Button text="Continue" variation={Button.STANDARD} />
    return hoistNonReactStatics(Crowned, Component);
  };
}
export default crown;
export { ThemeProvider, withClassNames, withPrefix };